// Landing-page FAQs. Question text appears as the always-visible trigger;
// answer text appears in the collapsible panel. Keep answers to 2-3
// sentences max — the section is editorial in style, not technical docs.
// First-person Mason voice. No claims about training data (see Promise II
// in MissionFounder — anonymous patterns may improve the model, but
// identity stays out of it).
export const LANDING_FAQS = [
  {
    q: 'How is this different from ChatGPT?',
    a: 'ChatGPT approaches Christianity from a neutral, outside perspective — it can talk about almost anything, but it wasn’t built for Scripture. Illuminate is built from a Christian perspective and purpose-built for the Bible: verse text comes from real licensed translations (never AI-generated), and every Bible reference cites its book, chapter, and verse so you can open your own Bible and verify it.',
  },
  {
    q: 'Why trust AI with my spiritual life?',
    a: 'AI isn’t inherently good or evil — it’s a tool, and how it’s built matters. Illuminate is shaped with specific guardrails: verse text comes from real translations (never generated), and every claim is cited so you can verify it. It shouldn’t be a substitute for Scripture, your pastor, or the Holy Spirit — use it like a study Bible: helpful, never the final word.',
  },
  {
    q: 'Is this denominationally skewed?',
    a: 'Illuminate is anchored to Scripture, not to a denomination. It holds the historic Christian basics — the Apostles’ and Nicene Creeds, Trinity, atonement, resurrection. On secondary issues where faithful Christians disagree (eschatology, baptism, spiritual gifts, church polity), the AI lays out the major positions and the Scripture behind each, so you can study the view that fits your tradition without being pushed toward one.',
  },
  {
    q: 'What if I’m new to faith and just exploring?',
    a: 'You’re welcome here. Illuminate doesn’t assume you’ve grown up in church or memorized verses. Ask the questions you’ve been afraid to ask — you’ll get honest answers grounded in Scripture, with no gatekeeping.',
  },
  {
    q: 'Is my data private?',
    a: 'You own your prayers, journals, and chats. I won’t sell them, and you can delete any of them at any time. Anonymous patterns may help improve how Illuminate responds — but your identity stays attached to your account, never to anyone else’s data.',
  },
  {
    q: 'Is it free to try?',
    a: 'Yes — you can use Illuminate completely free. No credit card required, and what’s free today stays free.',
  },
]
